module.exports = __webpack_public_path__ + "res/29-img_game_top.01e0d9fd7e1293f48fb64ea61e277e93.png";